import { render } from "./FpIconButton.vue?vue&type=template&id=68e2e94c&scoped=true"
import script from "./FpIconButton.vue?vue&type=script&lang=js"
export * from "./FpIconButton.vue?vue&type=script&lang=js"

import "./FpIconButton.vue?vue&type=style&index=0&id=68e2e94c&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e2e94c"]])

export default __exports__